export const OPEN_PARTICIPANT_DIALOG = 'OPEN_PARTICIPANT_DIALOG';
export const PARTICIPANT_ITEM_CHANGE = 'PARTICIPANT_ITEM_CHANGE';
export const RESET_PARTICIPANT_DETAILS = 'RESET_PARTICIPANT_DETAILS';
